export const executionDataSource = [
    { id: 1, label: "SMKT", value: "RSI" },
    { id: 2, label: "DTS/C-Stores", value: "INASE" },
    { id: 3, label: "WHSL", value: "ISCAM" },
    { id: 4, label: "Industry Data", value: "NST/NRI" },
    { id: 5, label: "Financial Data", value: "BPC" },
    { id: 6, label: "Shelf & Merchandising", value: "NSO" },
    { id: 7, label: "Pricing", value: "Price List" },
  ];